// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import "@hotwired/turbo-rails";
import { Application } from "@hotwired/stimulus";

import BlogMenuController from "../controllers/blog/menu_controller";
import CustomerModalController from "../controllers/customer/modal_controller";

const application = Application.start();

application.register("blog--menu", BlogMenuController);
application.register("customer--modal", CustomerModalController);
